import { createContext } from 'react';

export const AlertModalContext = createContext(null);
